var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm.name ? _c("div", [_vm._v(" " + _vm._s(_vm.$t("销售区域")) + "："), _c("span", {
    staticStyle: {
      color: "#1890ff"
    }
  }, [_vm._v(_vm._s(_vm.name))])]) : _vm._e(), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: !_vm.isEdit ? _vm.PREMIUMCOLUMNS : _vm.PREMIUMCOLUMNS1,
      "data-source": _vm.tableData,
      pagination: false,
      rowKey: "id",
      rowClassName: _vm.tableRowClass
    },
    scopedSlots: _vm._u([{
      key: "discountMode",
      fn: function (text, record, index) {
        return [_c("a-select", {
          staticStyle: {
            width: "100%"
          },
          attrs: {
            placeholder: _vm.$t("请选择"),
            disabled: !_vm.isEdit,
            getPopupContainer: triggerNode => triggerNode.parentNode,
            dropdownClassName: "mul-select-dropdown"
          },
          on: {
            change: function ($event) {
              return _vm.discountModeChange(index);
            }
          },
          model: {
            value: record.discountMode,
            callback: function ($$v) {
              _vm.$set(record, "discountMode", $$v);
            },
            expression: "record.discountMode"
          }
        }, [_c("a-select-option", {
          attrs: {
            value: "ratio"
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("折扣比例")) + " ")]), _c("a-select-option", {
          attrs: {
            value: "amount"
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("折扣金额")) + " ")])], 1)];
      }
    }, {
      key: "discountRatio",
      fn: function (text, record, index) {
        return [_vm.isEdit ? _c("a-input-number", {
          staticStyle: {
            width: "100%"
          },
          attrs: {
            placeholder: _vm.$t("单位") + "：%",
            formatter: value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            parser: value => `${value}`.replace(/\$\s?|(,*)/g, ""),
            precision: 2,
            disabled: record.discountMode == "ratio" ? false : true
          },
          on: {
            blur: function ($event) {
              return _vm.priceChange(index);
            }
          },
          model: {
            value: record.discountRatio,
            callback: function ($$v) {
              _vm.$set(record, "discountRatio", $$v);
            },
            expression: "record.discountRatio"
          }
        }) : _c("span", [_vm._v(_vm._s(text))])];
      }
    }, {
      key: "discountAmount",
      fn: function (text, record, index) {
        return [_vm.isEdit ? _c("a-input-number", {
          staticStyle: {
            width: "100%"
          },
          attrs: {
            placeholder: _vm.$t("单位") + "：" + _vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId, false)),
            formatter: value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            parser: value => `${value}`.replace(/\$\s?|(,*)/g, ""),
            disabled: record.discountMode == "amount" ? false : true,
            precision: 2
          },
          on: {
            blur: function ($event) {
              return _vm.priceChange(index);
            }
          },
          model: {
            value: record.discountAmount,
            callback: function ($$v) {
              _vm.$set(record, "discountAmount", $$v);
            },
            expression: "record.discountAmount"
          }
        }) : _c("span", [_vm._v(_vm._s(text))])];
      }
    }, {
      key: "price",
      fn: function (text) {
        return [_vm._v(" " + _vm._s(text) + " ")];
      }
    }, {
      key: "structureIds",
      fn: function (text, record) {
        return [_c("a-tree-select", {
          staticStyle: {
            width: "100%"
          },
          attrs: {
            "show-search": "",
            multiple: "",
            "tree-data": _vm.structureList,
            filterTreeNode: _vm.filterTreeOption,
            "replace-fields": {
              children: "children",
              key: "id",
              value: "id",
              title: "name",
              disabled: "disabled"
            },
            "dropdown-style": {
              maxHeight: "300px",
              overflow: "auto"
            },
            placeholder: _vm.$t("请选择"),
            "allow-clear": "",
            "tree-default-expand-all": "",
            disabled: !_vm.isEdit,
            getPopupContainer: triggerNode => triggerNode.parentNode
          },
          on: {
            change: function ($event) {
              return _vm.treeChange(_vm.index);
            }
          },
          model: {
            value: record.structureIds,
            callback: function ($$v) {
              _vm.$set(record, "structureIds", $$v);
            },
            expression: "record.structureIds"
          }
        })];
      }
    }, {
      key: "action",
      fn: function (text, record, index) {
        return [_c("a-button", {
          attrs: {
            type: "link"
          },
          on: {
            click: function ($event) {
              return _vm.handleDel(index);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("删除")))])];
      }
    }])
  }, [_vm._l(!_vm.isEdit ? _vm.PREMIUMCOLUMNS : _vm.PREMIUMCOLUMNS1, function (item, i) {
    return _c("span", {
      key: i,
      attrs: {
        slot: item.slots.title
      },
      slot: item.slots.title
    }, [_vm._v(_vm._s(_vm.$t(item.slots.title)))]);
  }), _c("span", {
    attrs: {
      slot: "折扣价格"
    },
    slot: "折扣价格"
  }, [_c("br"), _c("span", {
    staticStyle: {
      color: "#ffa39e",
      "font-size": "6px"
    }
  }, [_vm._v(_vm._s(_vm.$t("注：小数点后保留两位")))])]), _c("span", {
    attrs: {
      slot: "折扣比例"
    },
    slot: "折扣比例"
  }, [_c("br"), _c("span", {
    staticStyle: {
      color: "#ffa39e",
      "font-size": "6px"
    }
  }, [_vm._v(_vm._s(_vm.$t("注：小数点后保留两位")))])]), _c("template", {
    slot: "name"
  }, [_vm._v(" " + _vm._s(_vm.price) + " ")])], 2), _vm.isEdit ? _c("a-button", {
    staticStyle: {
      width: "100%",
      border: "1px solid #d9d9d9",
      "border-top": "0",
      "border-radius": "0"
    },
    attrs: {
      type: "link",
      size: "small"
    },
    on: {
      click: _vm.handleAdd
    }
  }, [_vm._v(_vm._s(_vm.$t("添加")))]) : _vm._e(), _c("div", {
    staticClass: "btnBox"
  }, [_vm.isEdit && _vm.name ? _c("a-button", {
    staticClass: "marginR15",
    on: {
      click: function ($event) {
        return _vm.cancelFun(_vm.index);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("取消")) + " ")]) : _vm._e(), _vm.isEdit ? _c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.onSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("保存")) + " ")]) : _vm._e(), !_vm.isEdit ? _c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function ($event) {
        return _vm.onEdit(_vm.index);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("编辑")) + " ")]) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };